import type { AgentChatMessage } from "../../types";
import { useAgentForm } from "./AgentFormContext";
import FormAnswer from "./FormAnswer";
import SubmittedForm from "./SubmittedForm";

type Props = { message: AgentChatMessage };

/**
 * A FORM row of the thread, in whichever of its two states it is in.
 *
 * The card the backend posts (no answer on it) is the live form — until the form has
 * been submitted, after which the row that carried the submission is what shows, and
 * the original card is not drawn a second time. Two rows, one card on screen.
 */
const FormMessage = ({ message }: Props) => {
  const { flow } = useAgentForm();
  const { form, formAnswer } = message;
  if (!form) return null;

  if (formAnswer) return <SubmittedForm message={message} />;

  if (flow.answered[form.formId]) return null;
  return <FormAnswer card={form} />;
};

export default FormMessage;
